/**
 * Site settings state for SEO modules.
 *
 * During SSR, the server entry populates these values from the DB.
 * On the client, values are hydrated from SSR state or fetched on demand.
 * All values have safe fallbacks matching the persisted bootstrap defaults.
 */

import { reactive } from 'vue';
import { seoDefaults } from '@site/seo-defaults';

export type SeoSiteSettings = {
  site_title: string;
  favicon_path: string | null;
  seo_default_title: string;
  seo_default_description: string;
  seo_default_social_image_path: string;
  organization_name: string;
  organization_logo_path: string;
};

const DEFAULTS: SeoSiteSettings = seoDefaults;

const currentSettings = reactive<SeoSiteSettings>({ ...DEFAULTS });

export function getSiteSettings(): SeoSiteSettings {
  return currentSettings;
}

export function setSiteSettings(settings: Partial<SeoSiteSettings>): void {
  Object.assign(currentSettings, settings);
}

export function resetSiteSettings(): void {
  Object.assign(currentSettings, DEFAULTS);
}

export function getSiteSettingsDefaults(): SeoSiteSettings {
  return { ...DEFAULTS };
}
